// UI classification only. The service validates and expands actual scan targets.
// Keep URL cleanup compatible with the service's normalizeHostname helper.
export function isDomainTarget(target) {
  if (typeof target !== 'string' || target.length > 8192) return false;
  const text = target.trim();
  if (!text) return false;
  const scheme = /^[a-z][a-z0-9+.-]*:\/\/(?:[^/@]*@)?/i;
  if (!scheme.test(text) && (text.includes(',') || /^(?:\d{1,3}\.){3}\d{1,3}(?:\s*[-/]|$)/.test(text))) return false;
  const host = text.replace(scheme, '').split(/[/?#]/)[0].split(':')[0]
    .toLowerCase().replace(/^www\./, '').replace(/\.+$/, '').trim();
  return host.length <= 253 && /^[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]?(\.[a-zA-Z]{2,})+$/.test(host);
}

export function publicIpRequest({ target, enabled, mode = 'auto', manual = '' }) {
  if (!enabled || !isDomainTarget(target)) return { public_ip_mode: 'none', public_ip: '' };
  return mode === 'manual'
    ? { public_ip_mode: 'manual', public_ip: manual }
    : { public_ip_mode: 'auto', public_ip: '' };
}
